module.exports = "<style data-bind=\"text: styleSheet\">\n\n</style>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/editorStyleSheet/editorStyleSheet.html
// module id = 645
// module chunks = 0